<template>
  <div class="main-content">
    <a-t-loader v-if="false" />

    <template v-else>
      <div class="page-content">
        <div class="container">
          <section class="email-template__block">

            <div class="email-template__block-top">

              <div class="block-top__title">
                <span>Follow Up Templates</span>
              </div>

              <div class="block-top__options">
                <a
                    class="story-templates__table__top-clear"
                    :style="{cursor: 'pointer'}"
                    @click="clearSearch"
                >Clear</a
                >
                <div class="options-search">
                  <div class="form-control-wrap">
                    <input
                        type="text"
                        placeholder="Search"
                        v-model="search"
                        class="form-control-search"
                    />
                    <div id="searchEmailTemplate" @click="searchEmailTemplate" class="form-control-icon">
                      <svg width="1em" height="1em" class="icon icon-search">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-search"></use>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="options-selects">
                  <div
                      :class="['select-wrapper', {'is-active': selects.typeEmailTemplate}]"
                      style="margin-left: 10px; max-width: 200px"
                      @click="openSelect('typeEmailTemplate')">
                    <div class="select-trigger">
                    <span class="select-trigger__name">{{
                        searchEmailTemplates.length > 0
                            ? searchEmailTemplates.map((op) => op.name).join(', ')
                            : 'All Type Email Template'
                      }}</span
                    ><span class="select-trigger__icon">
                      <svg width="1em" height="1em" class="icon icon-chevron">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                      ></span>
                    </div>
                    <div class="select-body">
                      <div class="select-inner js-scrollbar">
                        <div class="select-option">
                          <label
                              class="form-control-checkbox form-control-checkbox-add-flight"
                              @click.prevent.stop="searchEmailTemplates = []">
                            <input
                                type="checkbox"
                                :checked="searchEmailTemplates.length < 1" /><span
                              class="form-control-checkbox__box">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-check">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                          ><span class="select-option__name">All</span>
                          </label>
                        </div>
                        <div
                            v-for="op in dataTypeEmailTemplate"
                            :key="op.id"
                            :class="[
                          'select-option',
                          {
                            'is-selected': searchEmailTemplates
                              .map((item) => item.type)
                              .includes(op.type),
                          },
                        ]">
                          <label
                              class="form-control-checkbox form-control-checkbox-add-flight"
                              @click.prevent.stop="
                            () => {
                              if (
                                !searchEmailTemplates
                                  .map((item) => item.type)
                                  .includes(op.type)
                              ) {
                                searchEmailTemplates.push(op)
                              } else {
                                searchEmailTemplates = searchEmailTemplates.filter(
                                  (i) => !(i.type === op.type)
                                )
                              }
                            }
                          ">
                            <input
                                type="checkbox"
                                :checked="
                              searchEmailTemplates
                                .map((item) => item.type)
                                .includes(op.type)
                            "
                                @click.prevent.stop /><span
                              class="form-control-checkbox__box">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-check">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                          ><span class="select-option__name">{{
                              op.name
                            }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="options-buttons">
                  <button
                      class="btn btn--green"
                      @click="openModalEmailTemplate('new', newEmailTemplate)"
                  >
                    <span>Add Template</span>
                  </button>
                </div>
              </div>

            </div>

            <div class="email-template__block-content">
              <div class="block-content__top">
                <div class="top-name">
                  <span>Name</span>
                </div>
                <div class="top-tag">
                  <span>Tag</span>
                </div>
                <div class="top-last-update">
                  <span>Last Update</span>
                </div>
              </div>

              <a-t-loader v-if="isLoadingAllEmailTemplates"/>

              <template v-else>
                <span v-if="dataEmailTemplates.length === 0">NO EMAIL TEMPLATES</span>
                <div
                    v-else
                    class="block-content__item"
                    v-for="email in dataEmailTemplates"
                    :key="email.id"
                >
                  <div class="item-name">
                    <span>
                      {{email.name}}
                    </span>
                  </div>
                  <div class="item-tags">
                    <div class="item-tag" v-for="(tag, index) in email.tags" :key="index">

                      <img
                          v-if="tag === 'CLIMBING'"
                          src="/images/useful/svg/clients-icon1.svg"
                          alt="CLIMBING"
                      />
                      <img
                          v-if="tag === 'SAFARI'"
                          src="/images/useful/svg/clients-icon2.svg"
                          alt="SAFARI"
                      />
                      <img
                          v-if="tag === 'ISLAND'"
                          src="/images/useful/svg/clients-icon3.svg"
                          alt="ISLAND"
                      />
                      <img
                          v-if="tag === 'EXCURSION'"
                          src="/images/useful/svg/clients-icon4.svg"
                          alt="EXCURSION"
                      />

                      <span v-if="tag === 'FL1'">FL1</span>
                      <span v-if="tag === 'FL2'">FL2</span>
                      <span v-if="tag === 'CLIMBING'">Climbing</span>
                      <span v-if="tag === 'SAFARI'">Safari</span>
                      <span v-if="tag === 'EXCURSION'">Excursion</span>
                      <span v-if="tag === 'ISLAND'">Island</span>
                      <span v-if="tag === 'INVOICES'">Invoices</span>
                    </div>

                  </div>
                  <div class="item-last-update">
                    <span>{{createDate(email.updatedAt)}}</span>
                  </div>
                  <div class="item-options">
                    <button
                        type="button"
                        class="story-templates__table__dropdown-trigger"
                        :style="{position: 'relative'}"
                        @click="openMenu(email.id, 'allEmailTemplates')">
                      <svg width="1em" height="1em" class="icon icon-more">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-more"></use>
                      </svg>
                      <div
                          :class="['edit-popup edit-popup--short']"
                          :style="{zIndex: 100, right: '-6px'}"
                          v-if="email.menu"
                      >
                        <div class="form-control-group">
                          <span
                              @click="openModalEmailTemplate('edit', email)"
                              class="btn form-control-action"
                          ><span
                              class="form-control-action__icon icon--green">
                                  <svg
                                      width="1em"
                                      height="1em"
                                      class="icon icon-edit">
                                    <use
                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use></svg></span
                          ><span class="form-control-action__text"
                          >Edit</span
                          >
                          </span>
                        </div>
                        <div class="form-control-group">
                          <span
                              class="btn form-control-action"
                              @click.stop="isOpenModalDeleteEmailTemplate(email)">
                                <span
                                                                class="form-control-action__icon icon--red">
                                                              <svg
                                                                  width="1em"
                                                                  height="1em"
                                                                  class="icon icon-close">
                                                                <use
                                                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use></svg></span
                                                            >
                            <span class="form-control-action__text">Delete</span>
                          </span>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              </template>

            </div>

          </section>
        </div>
      </div>
    </template>

    <div class="modal-wrapper" v-if="deleteModal" :style="{zIndex: 300}">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup info-popup_park info-popup_park_2">
          <div class="edit-popup__header">
            <div class="info-title">
              <div class="info-title__icon">
                <svg width="3rem" height="3rem">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-error"></use>
                </svg>
              </div>
              <span class="info-title__heading"
              >Delete email-template</span
              >
            </div>
            <div class="edit-popup__close" @click="deleteModal = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <div class="info-popup__text">
            <p>
              Are you sure you want to delete {{ currentEmailTemplate.name }}?
            </p>
          </div>
          <div class="edit-popup__btns-2 edit-popup__btns--park">
            <button
                type="button"
                class="btn btn--green"
                @click="deleteModal = false">
              <span>No, go back</span>
            </button>
            <button
                type="button"
                class="btn btn--red"
                @click="deleteEmailTemplate(currentEmailTemplate)"
                >
              <span>Yes, delete</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <a-t-modal-email-template-settings
        v-if="isModalEmailTemplate"
        :currentEmailTemplate="currentEmailTemplate"
        @closeModalEmailTemplateOptions="closeModalEmailTemplate"
        @deleteModalEmailTemplateOptions="isOpenModalDeleteEmailTemplate"
        @changeEmailTemplateOptions="changeEmailTemplate"
    />

  </div>
</template>

<script>
import Vuex from "vuex";

import ATLoader from "@/components/Loaders/Loader";
import {actionTypes as actionTypesSettings, getterTypes as getterTypesSettings} from "@/store/modules/settings";
import {format, parse} from "date-fns";
import ATModalEmailTemplateSettings from "@/components/Modals/ModalEmailTemplateSettings";
export default {
  name: "AtEmailTemplate",
  data() {
    return {
      deleteModal: false,
      isModalEmailTemplate: false,
      currentEmailTemplate: {},
      newEmailTemplate: {
        name: "",
        texts: {
          EN: {
            subject: "",
            text: ""
          },
          DE: {
            subject: "",
            text: ""
          },
          RU: {
            subject: "",
            text: ""
          }
        },
        tags: []
      },
      search: '',
      searchEmailTemplates: [],
      selects: {
        typeEmailTemplate: false,
      },
      dataEmailTemplates: [],
      dataTypeEmailTemplate: [
        {name: 'FL1', type: 'FL1'},
        {name: 'FL2', type: 'FL2'},
        {name: 'Climbing', type: 'CLIMBING'},
        {name: 'Safari', type: 'SAFARI'},
        {name: 'Excursion', type: 'EXCURSION'},
        {name: 'Island', type: 'ISLAND'},
        {name: 'Invoices', type: 'INVOICES'},
      ]
    }
  },
  components: {ATModalEmailTemplateSettings, ATLoader},
  computed: {
    ...Vuex.mapGetters({
      allEmailTemplates: getterTypesSettings.allEmailTemplates,
      isLoadingAllEmailTemplates: getterTypesSettings.isLoadingAllEmailTemplates
    })
  },
  methods: {
    ...Vuex.mapActions({
      getEmailTemplates: actionTypesSettings.getEmailTemplates,
      createEmailTemplate: actionTypesSettings.createEmailTemplate,
      updateEmailTemplate: actionTypesSettings.updateEmailTemplate,
      deleteCurrentEmailTemplate: actionTypesSettings.deleteCurrentEmailTemplate
    }),
    closeModalEmailTemplate(status) {
      this.isModalEmailTemplate = status
    },
    openModalEmailTemplate(flag, email) {
      if (flag === 'new') {
        this.isModalEmailTemplate = true
        this.currentEmailTemplate = Object.assign({type: flag}, email)
      }
      if (flag === 'edit') {
        this.isModalEmailTemplate = true
        this.currentEmailTemplate = Object.assign({type: flag}, email)
      }
    },
    findAllEmailTemplates() {
      this.getEmailTemplates().then(() => {
        this.dataEmailTemplates = this.allEmailTemplates
      })
    },
    openMenu(id, type) {
      this[type].map((item) =>
          item.id === id ? item.menu = !item.menu : item.menu = false
      )
    },
    isOpenModalDeleteEmailTemplate(email) {
      this.currentEmailTemplate = email
      if (this.currentEmailTemplate) {
        this.deleteModal = true
      }
    },
    deleteEmailTemplate(email){
      this.deleteCurrentEmailTemplate({
        id: email.id
      }).then(() => {
        this.deleteModal = false
        this.isModalEmailTemplate = false
        this.findAllEmailTemplates()
      })
    },
    changeEmailTemplate(email){
      if (email.type === 'new') this.createEmailTemplate(email).then(() => {
        this.newEmailTemplate.name = ''
        this.newEmailTemplate.texts.EN.subject = ''
        this.newEmailTemplate.texts.EN.text = ''
        this.newEmailTemplate.texts.DE.subject = ''
        this.newEmailTemplate.texts.DE.text = ''
        this.newEmailTemplate.texts.RU.subject = ''
        this.newEmailTemplate.texts.RU.text = ''
        this.newEmailTemplate.tags = []
        this.findAllEmailTemplates()
      })
      if (email.type === 'edit') this.updateEmailTemplate(email).then(() => this.findAllEmailTemplates())
    },
    clearSearch() {
      this.dataEmailTemplates = this.allEmailTemplates
      this.search = ''
      this.searchEmailTemplates = []
    },
    createDate(createDate) {
      let options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }
      return new Date(createDate).toLocaleString('en-GB', options)
    },
    searchEmailTemplate(){
      this.dataEmailTemplates = this.allEmailTemplates

      if (this.search.length > 0 && !this.searchEmailTemplates.length > 0) {
        this.dataEmailTemplates = this.allEmailTemplates.filter(e => e.name.toLowerCase().includes(this.search.toLowerCase()))
      }

      if (!this.search.length > 0 && this.searchEmailTemplates.length > 0) {
        this.dataEmailTemplates = this.allEmailTemplates.filter(email => this.searchEmailTemplates.every(s => email.tags.includes(s.type)))
      }

      if (this.search.length > 0 && this.searchEmailTemplates.length > 0) {
        this.dataEmailTemplates = this.allEmailTemplates.filter(e => e.name.toLowerCase().includes(this.search.toLowerCase()))
        this.dataEmailTemplates = this.dataEmailTemplates.filter(email => this.searchEmailTemplates.every(s => email.tags.includes(s.type)))
      }
    },
    openSelect(type = false) {
      this.selects = {
        status: false,
        [type]: !this.selects[type],
      }
    },
  },
  mounted() {
    this.findAllEmailTemplates()
    // const a = document.getElementById("searchEmailTemplate");
    // window.addEventListener("keydown", function(e) {
    //     if (e.keyCode === 13)  a.click()
    //   });


    window.addEventListener('click', (event) => {
      event.stopPropagation()
      if (!event.target.closest('.select-wrapper')) {
        this.selects = {
          status: false,
          operator: false,
          date: false
        }
      }
      if (!event.target.closest('.story-templates__table__dropdown-trigger')) {
        this.dataEmailTemplates.map((item) =>
            item.menu ? item.menu = !item.menu : item.menu = false)
      }
    })
  }
}
</script>
